/**
 * Enum trạng thái nộp & kiểm tra
 */
export default {
  PublishDictionaryData: 0,
  SentEstimate: 1,
  SendBackEstimate: 2,
  Complete: 3,
  RequestSubmitEstimate: 4,
  Test: 5,
  ApproveRevoke: 6,
  PublishSentNotification: 7,
  SentEstimateSectorWide: 8,
  SentEstimateArrgrate: 9,
  OrganizationInformation: 10,
  SendBackEstimateArrgrate: 11,
  CompleteArrgrate: 12,
  SendSyncTemplates: 13,
  RequestSubmitEstimateThreeYear: 14,
  SendSyncDictionaryCeilingExpense: 15,
  SendNotiSyncDictionaryCeilingExpense: 16,
  SubmitEstimateThreeYear: 17,
  SendBackEstimatePTC: 18,
  CompletePTC: 19,
  CancelComplete: 20,
  CancelCompleteArrgrate: 21, // PTC hủy hoàn thành chủ quản
  CancelCompletePTC: 22, // Sở tài chính hủy hoàn thành
  ApplyEnactToOtherOrg: 26, // Áp dụng cho các cơ quan khác
  PublishToOtherOrg: 27, // Áp dụng cho các cơ quan khác
  DeliverAllocation: 28, // Giao dự toán
  ReportSummary: 30, // Báo cáo tổng hợp
  SDNSSentEstimate: 32, // nộp dự toán đầu năm
  SendBackInitial: 33, // Gửi trả kiểm tra đầu năm
  CompleteInitial: 34, // Hoàn thành kiểm tra đầu năm
  CancelCompleteInitial: 38, // HỦy Hoàn thành kiểm tra đầu năm
  ObserverMovementSentData: 39, // Gửi dữ liệu tình hình thực hiệm
  DeliverAddAllocation: 40, // luồng giao dự toán bổ sung
};
